/* ==========================================================================
   loq-download-popup.js — loquita.com.ar regalitos template

   Variant detection (verified against the live page):
   - The variant picker radios have name "Formato-1\n" and values "PDF"/"JPG".
   - The checked radio's value DOES change when the visitor switches variant.
   - We read that checked value, map it to a variant ID via LOQ_BY_OPTION,
     then to the URL via LOQ_DOWNLOADS[variantId].

   Submit pattern is WMB's: no preventDefault on a valid submit, no
   form.submit(); the real button posts the Shopify customer form natively
   into the hidden iframe (avoids the bot captcha). Download via blob so the
   file actually saves and the page stays put.
   ========================================================================== */
(function () {
  'use strict';

  var modal, form, tagsInput, marketingHidden, marketingCheckbox, openBtns;

  // Read the currently selected option value from the variant picker radios.
  function getCheckedOptionValue() {
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      // Only consider radios that belong to the variant picker
      if (radios[i].checked && radios[i].closest('variant-selects, variant-radios, .product-form__input')) {
        return radios[i].value;
      }
    }
    return null;
  }

  function getCurrentVariantId() {
    var value = getCheckedOptionValue();
    if (value && window.LOQ_BY_OPTION && window.LOQ_BY_OPTION[value]) {
      return window.LOQ_BY_OPTION[value];
    }
    return window.LOQ_DEFAULT_ID || null;
  }

  function getCurrentVariantData() {
    if (!window.LOQ_DOWNLOADS) return null;
    var id = getCurrentVariantId();
    return id ? window.LOQ_DOWNLOADS[id] : null;
  }

  /* ---- Open / close -------------------------------------------------- */

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = document.getElementById('loq-first-name');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- Download (blob; real save; page stays put) -------------------- */

  function triggerDownload(url) {
    if (!url) return;
    var filename = url.split('/').pop().split('?')[0] || 'descarga';
    fetch(url)
      .then(function (res) { return res.blob(); })
      .then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.setAttribute('download', decodeURIComponent(filename));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 10000);
      })
      .catch(function () { window.open(url, '_blank'); });
  }

  /* ---- Submit (WMB pattern) ------------------------------------------ */

  function handleSubmit(event) {
    var data = getCurrentVariantData();

    var fn = document.getElementById('loq-first-name');
    var ln = document.getElementById('loq-last-name');
    var em = document.getElementById('loq-email');

    var valid =
      fn && ln && em &&
      fn.value.trim() && ln.value.trim() && em.value.trim() &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim());

    if (!valid) {
      event.preventDefault();
      [].forEach.call(document.querySelectorAll('#loq-download-form [required]'), function (el) {
        el.reportValidity && el.reportValidity();
      });
      return;
    }

    if (!data || !data.downloadUrl) {
      event.preventDefault();
      return;
    }

    if (tagsInput) tagsInput.value = data.productTag || '';

    if (marketingHidden && marketingCheckbox) {
      marketingHidden.value = marketingCheckbox.checked ? 'true' : 'false';
    }

    form.setAttribute('target', 'loq-hidden-frame');

    setTimeout(function () { closeModal(); }, 1200);
    setTimeout(function () { triggerDownload(data.downloadUrl); }, 400);

    // Do not preventDefault here.
    // Do not call form.submit().
    // Let the real button submit the Shopify form natively into the hidden iframe.
  }

  /* ---- Init ---------------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', function () {
    modal             = document.getElementById('loq-download-modal');
    if (!modal) return;
    form              = document.getElementById('loq-download-form');
    tagsInput         = document.getElementById('loq-customer-tags');
    marketingHidden   = document.getElementById('loq-accepts-marketing-hidden');
    marketingCheckbox = document.getElementById('loq-consent');
    openBtns          = document.querySelectorAll('[data-loq-open]');

    [].forEach.call(openBtns, function (btn) {
      btn.addEventListener('click', openModal);
    });

    [].forEach.call(modal.querySelectorAll('[data-loq-close]'), function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (form) form.addEventListener('submit', handleSubmit);
  });

})();